import api from "@/services/api";
import type { InspectionFilters, InspectionsResponse } from "../types";

export const InspectionsListAll = async (filters: InspectionFilters = {}) => {
	const response = await api.get<InspectionsResponse>(
		"/api/checklist/answer/paginated",
		{
			params: {
				Client: filters.Client,
				Inspector: filters.Inspector,
				SubmittedAt: filters.SubmittedAt,
				Plate: filters.Plate,
				PageNumber: filters.PageNumber || 1,
				PageSize: filters.PageSize || 10,
				SortBy: filters.SortBy,
				SortDirection: filters.SortDirection,
				Search: filters.Search,
			},
		}
	);

	return response.data;
};

export const getInspectionPdfUrl = async (answerId: number) => {
	const response = await api.get<{ answerId: number; fileUrl: string }>(
		`/api/checklist/answer/${answerId}/pdf/url`
	);
	return response.data.fileUrl;
};

export const reprocessInspectionPdf = async (answerId: number) => {
	const response = await api.post(
		`/api/checklist/answer/${answerId}/pdf/reprocess`,
		{}
	);
	return response.data;
};
